import type { Animation } from '@ionic/core';
import {
  DURATION_MEDIUM_4,
  EASING_EMPHASIZED_DECCELERATE,
  createAnimation,
  fadeIn,
  scale,
} from '../../../utils/animations';

export function dialogOpenAnimation(dialogEl: HTMLElement, backdropEl: HTMLSyBackdropElement): Animation {
  const dialogOpenAnim = createAnimation();
  const backDropAnim = fadeIn()
    .duration(DURATION_MEDIUM_4)
    .easing(EASING_EMPHASIZED_DECCELERATE)
    .addElement(backdropEl);
  const dialogDivFade = fadeIn().duration(DURATION_MEDIUM_4).easing(EASING_EMPHASIZED_DECCELERATE).addElement(dialogEl);
  const dialogDivScale = (scale({ from: '1.15', to: '1' }) as Animation)
    .beforeStyles({ 'transform-origin': 'center' })
    .easing(EASING_EMPHASIZED_DECCELERATE)
    .duration(DURATION_MEDIUM_4)
    .addElement(dialogEl);

  dialogOpenAnim.addAnimation(backDropAnim);
  dialogOpenAnim.addAnimation(dialogDivFade);
  dialogOpenAnim.addAnimation(dialogDivScale);
  return dialogOpenAnim;
}
